// Libraries
var React = require('react');

// Style
require('./GenericEmbed.scss');

class GenericEmbedModule extends React.Component {
	createContent = _ => {
		return {__html: this.props.data.embedCode};
	};

	render() {
		
		return (
			<div id={this.props.data.id} className={`${this.props.data.fullWidth ? "GenericEmbed GenericEmbed--full-width" : "GenericEmbed"}`}>
				<div className="GenericEmbed__container">
					<div dangerouslySetInnerHTML={this.createContent()}></div>
				</div>
			</div>
		);
	}
};

module.exports = GenericEmbedModule;



// WEBPACK FOOTER //
// ./src/components/GenericEmbed/GenericEmbedModule.js